/*  MUI  */
import { Grid, Tab } from '@mui/material';

/*  Shared  */
import { PageTitle } from 'application/Shared/Components/App';
import { AdminBackButton } from 'application/Shared/Components/Buttons/BackButton';
import { MUITabsWrapper } from 'application/Shared/Components/MUITabsWrapper';
import { Route, SessionHelper } from 'application/Shared/Helpers';
import { ManageUsers, Permissions } from 'application/Shared/Pages';

/* Hooks */
import { useSession } from 'hooks/redux/Selectors/session';

/*  React  */
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useParams } from 'react-router';

const Page = () => {
    const { tab } = useParams();
    switch (tab) {
        case 'permissions':
            return <Permissions noTitle />;
        case 'users':
        default:
            return <ManageUsers />;
    }
};

const PageTabs = () => {
    const { t } = useTranslation();
    const { clientId, partnerId, tab } = useParams();
    const activeTab = tab ?? 'users';

    const baseAdminRoute = Route.buildBaseAdminRoute({
        clientId,
        partnerId
    });

    return (
        <MUITabsWrapper value={activeTab}>
            <Tab
                component={Link}
                to={`${baseAdminRoute}/manageUsers/users`}
                value="users"
                label={t('Common.manage_users')}
                data-trackid="admin_manageUsers_users"
            />
            <Tab
                component={Link}
                to={`${baseAdminRoute}/manageUsers/permissions`}
                value="permissions"
                label={t('Common.manage_permission_groups')}
                data-trackid="admin_manageUsers_permissions"
            />
        </MUITabsWrapper>
    );
};

const PageContent = ({ anm }) => {
    if (anm) {
        return <Page />;
    }

    return (
        <>
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <PageTabs />
                </Grid>
            </Grid>
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <Page />
                </Grid>
            </Grid>
        </>
    );
};

export const AdminManageUsers = () => {
    const { t } = useTranslation();
    const session = useSession();

    const sessionHelper = new SessionHelper(session);
    const anm = sessionHelper.isANM();

    return (
        <>
            <PageTitle title={t('Common.manage_users')} />
            <AdminBackButton linkTo="/configure" />
            <PageContent anm={anm} />
        </>
    );
};
